import React, { CSSProperties, ReactElement } from 'react';
import styled from 'styled-components';
import { SystemIconButton } from '../../../Icon/SystemIconButton';
import { FOCUS_ANIMATION_CLASS_NAME } from './scrollToFilterByKey';

export interface DataTableFilterProps<Q extends string> {
  label: string;
  id: Q;
  value: unknown;
  children: ReactElement;
  onClear?: () => void;
  disableDeleteButton?: boolean;
  hidden?: boolean;
  style?: CSSProperties;
  group?: string;
}

export const DataTableFilterWrapper = <Q extends string>({
  children,
  onClear = () => {},
  disableDeleteButton,
  style,
  hidden,
  id
}: DataTableFilterProps<Q>) => {
  if (hidden) {
    return null;
  }
  return (
    <StyledFilter
      data-test="data-table-filter-wrapper"
      className="outlined"
      style={style}
      $hidden={hidden}
      id={`data-table-filter-${id}`}
    >
      {children}
      {!disableDeleteButton && (
        <StyledDeleteButtonWrapper className="delete-action">
          <SystemIconButton iconName="delete" onClick={onClear} dataTest="data-table-filter-wrapper-delete" />
        </StyledDeleteButtonWrapper>
      )}
    </StyledFilter>
  );
};

const StyledFilter = styled.div<{ $hidden?: boolean }>`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacingSize.xl};
  display: ${({ $hidden }) => ($hidden ? 'none' : undefined)};
  border: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
  border-radius: 4px;
  position: relative;
  padding: ${({ theme }) => theme.spacingSize.m};

  &.${FOCUS_ANIMATION_CLASS_NAME} {
    animation: set-focus 1s ease-out forwards;
  }

  &:hover {
    .delete-action {
      opacity: 1;
      transition: opacity 0.3s;
    }
  }

  @keyframes set-focus {
    0% {
      background-color: transparent;
    }
    50% {
      background-color: ${({ theme }) => theme.colorPrimaryContainer};
    }
    100% {
      background-color: transparent;
    }
  }
`;

const StyledDeleteButtonWrapper = styled.div`
  position: absolute;
  opacity: 0;
  right: -${({ theme }) => theme.spacingSize.xl};
  top: -${({ theme }) => theme.spacingSize.xl};
  z-index: 10;
`;
